import React, { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router";
import ReactPaginate from "react-paginate";
import { Spinner, Col, Row, Form } from "react-bootstrap-v5";
import individualServices from "../../Services/individualServices";
import { ChangeStatus } from "../../Components";
import Loader from "../../Components/Loader";
// import locationServices from '../../Services/locationServices'
import { MdDeleteForever, MdEdit, MdVisibility } from "react-icons/md";
import CheckAccess from "../../Function/CheckAccess";
// import { RiBankLine } from "react-icons/ri";
let currentPage1 = 1;

export const IndividualList = () => {
  const [individualsList, setIndividualsList] = useState([]);
  const [pagination, setPagination] = useState({ page: 1, limit: 10 });
  const [search, setSearch] = useState('');
  const [currentPage, setCurrentPage] = useState(currentPage1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [loader, setLoader] = useState(false);
  const [filter, setFilter] = useState("");
  // const [countryValue, setCountryValue] = useState("");

  const history = useHistory();
  const imgRef = useRef();

  useEffect(() => {
    getIndividualsList(filter, currentPage);
  }, [currentPage]);

  const getIndividualsList = (val, page) => {

    currentPage1 = page

    setLoader(true);
    let param = {"item" : 2211};
    if (val) {
      setFilter(val);
      param = {
        ...param,
        // search: search,
        page: page,
        limit: pagination.limit,
        type: val,
      };
    } else {
      param = {
        ...param,
        // search: search,
        page: currentPage,
        limit: pagination.limit,
      };
    }
    // if (countryId) {
    //   param["search"] = countryId;
    //   param["page"] = 1;
    // }
    if (search.length > 3) {
      param["page"] = currentPage1;
      param["search"] = search;
    }
    individualServices.get_individual(param).then((res) => {
      if (res.status) {
        setLoader(false);
        setIndividualsList(res.data);
        // setPagination({ ...pagination, ...res.pagination });
        setPagination((prev) => ({ ...prev, ...res.pagination }));
        // setPagination(res.pagination)
      } else {
        setLoader(false);
      }
    });
  };

  const onModalSubmit = () => {
    let postData = {
      id: isModalOpen._id,
      user_status: isModalOpen.user_status === "ACTIVE" ? "INACTIVE" : "ACTIVE",
    };
    individualServices.update_individual(postData).then((res) => {
      setIsModalOpen(false);
      getIndividualsList(filter);
    });
  };

  const onPageChangeEvent = (e) => {
    currentPage1 = e.selected + 1
    setLoader(true);
    setCurrentPage(e.selected + 1);
  };

  // const onSelectCountry = (e) => {
  //   setCountryValue(e);
  //   getIndividualsList(e.value);
  // };

  useEffect(()=>{
    getIndividualsList(filter, 1)
  }, [search.length > 3 && search])

  // const onPageChangeEvent = (e) => {
  //   setCurrentPage(e.selected + 1);
  // };


  return (
    <div className="row">
      <div className="col-lg-12">
        <div className="card">
          <div className="card-body">
            <Row className="mb-2">
              <Col md={3}>
                <input
                  type="text"
                  className={"form-control"}
                  placeholder="Search..."
                  onChange={(e) =>
                    setSearch(e.target.value )
                  }
                  onKeyPress={(e) => e.key === "Enter" && getIndividualsList(filter, 1)}
                  onKeyUp={(e) =>
                    e.key === "Backspace" &&
                    search.length <= 0 &&
                    getIndividualsList(filter, 1)
                  }

                />
              </Col>
              <Col md={3}>
                <Form.Select
                  aria-label="Default select example"
                  name="type"
                  onChange={(e) => getIndividualsList(e.target.value, 1)}
                  onKeyUp={(e) => e.key === "Backspace" && search.length <= 1 && getIndividualsList()}
                >
                  <option value="">Select</option>
                  <option value="individual">Individual</option>
                  <option value="commercial">Commercial</option>
                  <option value="trade_partner">Trade Partner</option>
                </Form.Select>
              </Col>
              <Col md={6} className="d-flex justify-content-end">
                {CheckAccess(2211, "add") && (
                  <button
                    className="btn btn-primary w-sm waves-effect waves-light mx-3"
                    onClick={() => history.push("/add-Individuals")}
                  >
                    Add Individuals
                  </button>
                )}

                <input ref={imgRef} type="file" className="d-none" />
              </Col>
            </Row>
            <div className="table-responsive">
              <table className="table table-centered table-nowrap mb-0">
                <thead className="table-light">
                  <tr>
                    <th>S no.</th>
                    <th> Name</th>
                    <th>Email</th>
                    <th>Contact No.</th>
                    <th>Type</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    (individualsList.length > 0 &&
                      individualsList.map((item, key) => (
                        <tr key={key}>
                          <td className="text-body fw-bold">
                            {(pagination.page - 1) * pagination.limit +
                              (key + 1)}
                          </td>
                          <td>{item.user_full_name}</td>
                          <td>{item.user_email} </td>
                          <td>{item.user_phone_number}</td>
                          <td>{item.type ? item.type.split("_").join(" ") : "individual"}</td>
                          <td>
                            <span
                              className={
                                "badge rounded-pill font-size-12 pointer" +
                                (item.user_status === "ACTIVE"
                                  ? " bg-success"
                                  : " bg-soft-danger")
                              }
                              onClick={() => setIsModalOpen(item)}
                            >
                              {item.user_status}
                            </span>
                          </td>
                          <td>
                            {CheckAccess(2211, "edit") && (
                              <MdEdit
                                className="pointer"
                                onClick={() =>
                                  history.push(
                                    "/edit-individuals?id=" + item._id,
                                    item
                                  )
                                }
                                color="#0323fe"
                                size="25px"
                              />
                            )}

                            <MdVisibility
                              className="pointer"
                              onClick={() =>
                                history.push(
                                  "/individual-details?id=" + item._id,
                                  item
                                )
                              }
                              color="#0323fe"
                              size="25px"
                            />
                          </td>
                        </tr>
                      ))) || (
                      <tr>
                        <td colSpan={20} className="text-center bg-warning">
                          List not available
                        </td>
                      </tr>
                    )
                    // <div className="text-center w-100 bg-warning my-5">
                    //   <h6 className="py-2"> list not available </h6>
                    // </div>
                  }
                </tbody>
              </table>
            </div>
          </div>
          {individualsList.length > 0 &&
            !loader &&
            pagination.totalRecord > pagination.limit && (
              <ReactPaginate
                previousLabel={
                  <img
                    src="assets/images/prev.svg"
                    height={15}
                    alt="not found"
                  />
                }
                forcePage={currentPage - 1}
                nextLabel={
                  <img
                    src="assets/images/next.svg"
                    height={15}
                    alt="not found"
                  />
                }
                breakLabel={"..."}
                breakClassName={"break-me"}
                pageCount={Math.ceil(pagination.totalRecord / pagination.limit)}
                marginPagesDisplayed={2}
                pageRangeDisplayed={3}
                onPageChange={(e) => onPageChangeEvent(e)}
                containerClassName={"pagination"}
                activeClassName={"active"}
              />
            )}
          <Loader isShow={loader} />
        </div>
        {Boolean(isModalOpen) && (
          <ChangeStatus
            isOpen={Boolean(isModalOpen)}
            title="Update Status"
            message={`Are you sure want to ${
              isModalOpen.user_status === "ACTIVE" ? "Inactive" : "Active"
            } status ?`}
            onSubmitEvent={() => onModalSubmit()}
            handleClose={() => setIsModalOpen(false)}
          />
        )}
        {Boolean(deleteModalOpen) && (
          <ChangeStatus
            isOpen={Boolean(deleteModalOpen)}
            title="Delete"
            message={`Are you sure want to delete?`}
            onSubmitEvent={() => setDeleteModalOpen(false)}
            handleClose={() => setDeleteModalOpen(false)}
          />
        )}
      </div>
    </div>
  );
};
